import React from 'react';
import { FormLayoutProps, ApplicationLayoutProps, ProtectedContainerProps, getPages as getPagesCore, CustomPageLoader } from 'omni-package-react-core';
import Constants from '../../Constants';

const NewMessagePage = () => <CustomPageLoader loader={() => import('../NewMessagePage')} />;
const MessageDetailsPage = () => <CustomPageLoader loader={() => import('../MessageDetailsPage')} />;
const SecuredMessagingPage = () => <CustomPageLoader loader={() => import('../SecuredMessagingPage')} />;
const ConfirmationPage = () => <CustomPageLoader loader={() => import('../ConfirmationPage')} />;

const getPages = (
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
  FormLayout: React.FC<FormLayoutProps>,
  ApplicationLayout: React.FC<ApplicationLayoutProps>,
) => getPagesCore([
  {
    exact: true,
    path: '',
    component: (
      <ApplicationLayout name="SecuredMessaging" lob="corpo">
        <SecuredMessagingPage />
      </ApplicationLayout>),
    protected: true,
    index: true,
  },
  {
    exact: true,
    path: Constants.NewMessagePageSegment,
    component: (
      <FormLayout returnPage={Constants.BasePagePath} name="SecuredMessaging-NewMessage" lob="corpo">
        <NewMessagePage />
      </FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: `${Constants.MessageDetailsPageSegment}/:messageId`,
    component: (
      <ApplicationLayout name="SecuredMessaging-MessageDetails" lob="corpo">
        <MessageDetailsPage />
      </ApplicationLayout>),
    protected: true,
  },
  {
    exact: true,
    path: `${Constants.NewMessageConfirmationPageSegment}/:messageId`,
    component: (
      <FormLayout returnPage={Constants.BasePagePath} name="SecuredMessaging-Confirmation" lob="corpo">
        <ConfirmationPage />
      </FormLayout>),
    protected: true,
  },
], ProtectedContainer, isAuthenticated, Constants.BasePageSegment);

export default getPages;
